<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div class="row">
        <!-- TITULO VEHICULO FRENTE -->
        <div v-if="isFieldVisible('photo_vehicle_title_front')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_vehicle_title_front" class="form-label text-left">{{ getFieldDescription('photo_vehicle_title_front') }}</label>
            </div>
            <div>
            <div>
                <div @click="openCamera('photo_vehicle_title_front')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_vehicle_title_front'"
                  :id="'photo_vehicle_title_front'"
                  style="display: none;"
                  @change="onFileChange('photo_vehicle_title_front')"
                />
              </div>
          </div>
            <div class="btn tbn-block btn-custom mt-3" v-if="photo_vehicle_title_front" @click="openImageModal(photo_vehicle_title_front)">Ver Imagen</div>
          </div>
        </div>
        <!-- TITULO VEHICULO DORSO -->
        <div v-if="isFieldVisible('photo_vehicle_title_back')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_vehicle_title_back" class="form-label text-left">{{ getFieldDescription('photo_vehicle_title_back') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_vehicle_title_back')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_vehicle_title_back'"
                  :id="'photo_vehicle_title_back'"
                  style="display: none;"
                  @change="onFileChange('photo_vehicle_title_back')"
                />
              </div>
            </div>
            <div class="btn tbn-block btn-custom mt-3" v-if="photo_vehicle_title_back" @click="openImageModal(photo_vehicle_title_back)">Ver Imagen</div>
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4"/>
    </div>
    
    <!-- MODAL -->
    <ShowImagesModal
    :modalId="'imageModalVehicleTitle'"
    :currentImage="currentImage"
    :currentImageName="currentImageName"
    />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import ShowImagesModal from '../../modals/ShowImages';
import ImageCompressor from 'image-compressor.js'; 
import { rotateImageIfNeeded } from '../../../Utils/imageUtils';  

export default {
  name: 'FormPhotoVehicleTitleFile',
  props: {
    data: Object,
  },
  components: {
    ShowImagesModal,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const currentImage = ref(null);
    const currentImageName = ref('');

    const photo_vehicle_title_front = ref(null);
    const photo_vehicle_title_back = ref(null);

    const formData = ref({
      photo_vehicle_title_front_id: photo_vehicle_title_front.value,
      photo_vehicle_title_back_id: photo_vehicle_title_back.value,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.photo_vehicle_title_front || dataCompany.value.photo_vehicle_title_back)
        );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalVehicleTitle').modal('show');
    };

    const onFileChange = async (fieldName) => {
      const fileFields = {
        photo_vehicle_title_front: photo_vehicle_title_front,
        photo_vehicle_title_back: photo_vehicle_title_back,
      };

      const fileInput = document.getElementById(fieldName);

      try {
        const rotatedFile = await rotateImageIfNeeded(fileInput.files[0], 90);
        const compressedFile = await compressImage(rotatedFile);
        fileFields[fieldName].value = compressedFile;
        emitFieldChanged();
      } catch (error) {
        console.error('Error al comprimir la imagen:', error);
      }
    };

    const compressImage = (file) => {
      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor();
        compressor.compress(file, {
          maxWidth: 800,
          maxHeight: 600,
          quality: 1,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result);
          },
          error(error) {
            reject(error);
          },
        });
      });
    };

    const emitFieldChanged = () => {
      const formFields = {
        photo_vehicle_title_front_id: photo_vehicle_title_front.value,
        photo_vehicle_title_back_id: photo_vehicle_title_back.value,
      };

      const newFormData = {};

      for (const [key, value] of Object.entries(formFields)) {
        if (dataCompany.value && dataCompany.value[key.replace('_id', '')]) {
          newFormData[key] = value;
        }
      }

      const isFormDataChanged = JSON.stringify(newFormData) !== JSON.stringify(formData.value);

      if (isFormDataChanged) {
        formData.value = newFormData;
        emit('formDataChanged', formData.value);
      }
    };

    const openCamera = async (fieldName) => {
      try {
        const inputElement = document.getElementById(fieldName);
        inputElement.click();
      } catch (error) {
        console.error('Error al abrir la ventana de selección de archivo:', error);
      }
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      openImageModal,
      onFileChange,
      currentImage,
      currentImageName,
      emitFieldChanged,
      formData,
      photo_vehicle_title_front,
      photo_vehicle_title_back,
      openCamera,
    };
  },
};
</script>
